import React from 'react'
import { Platform } from 'react-native'

import { B2, SH1, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import CategoryNotEligibleSvg from '../../assets/svg/categoryNotEligible'

const CategoryNotEligible = ({ categoryName }: { categoryName?: string }) => {
  const isWeb = Platform.OS === 'web'
  return (
    <Stack
      className={`${
        isWeb ? 'bg-grays-20 h-3/5' : 'mb-4 mt-6'
      } items-center justify-center bg-white`}
    >
      <CategoryNotEligibleSvg width={90} height={90} />
      <SH1 className="text-grays-80 mt-2">
        {i18n.t('recommendationState.ineligible.sorry')}
      </SH1>
      {categoryName && (
        <B2 className="text-grays-70 mt-1 ">
          {i18n.t('recommendationState.ineligible.categoryNotEligible', {
            categoryName: categoryName,
          })}
        </B2>
      )}
    </Stack>
  )
}

export default CategoryNotEligible
